import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { AccountType } from '../../../types'

export const collection = 'accounts'

export const schema = new schemas.Entity(collection, undefined, {
  processStrategy: (account: AccountType) => ({
    ...account,
    needsAuthorization: !!account.needsAuthorization,
  }),
})

type FetchQueryType = {
  serviceId: string
  accountId: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ serviceId, accountId }: FetchQueryType) =>
    callApi(`${apiBase}/services/${serviceId}/accounts/${accountId}`, schema)

type RemoveBodyType = {
  serviceKey: string
  accountId: string
}

export const remove =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { serviceKey, accountId }: RemoveBodyType) =>
    callApi(`${apiBase}/services/${serviceKey}/accounts/${accountId}`, schema, {
      method: 'DELETE',
    })

type UpdateQueryType = {
  serviceId: string
}

export const update =
  (callApi: CallApi, apiBase: string) =>
  ({ serviceId }: UpdateQueryType, account: AccountType) =>
    callApi(`${apiBase}/services/${serviceId}/accounts/${account.id}`, schema, {
      method: 'PUT',
      body: account,
    })
